import type { ToolComponentData } from '@/lib/tool-adapter'

/** FRIDGE-794: the implemented group chooser, shared by visible copy and route SEO. */
export const QUIZ_COPY = {
  heading: 'Your perfect fridge search starts here.',
  supporting: 'Tell us what matters. Explore refrigerator and freezer groups, with prices where available.',
  description: 'Answer five questions at Fridge.com to explore refrigerator and freezer groups, with prices where available. Compare product details before choosing.',
} as const

export const QUIZ_TOOL_DEFINITION: ToolComponentData = {
  slug: 'find-your-fridge',
  name: 'Find Your Fridge',
  shortDescription: QUIZ_COPY.supporting,
  mediumDescription: QUIZ_COPY.description,
  longDescription: 'Household, style, location and budget answers choose a starting product group. The final priority question is for your comparison and does not change the group. Results are catalog examples, not individually scored recommendations. Verify dimensions, features and available offers on each product page.',
  metaTitle: 'Find Your Fridge | Free Tool | Fridge.com',
  keywords: ['find your fridge', 'refrigerator quiz', 'refrigerator and freezer groups'],
  category: 'Kitchen Planning',
  howItWorks: { intro: QUIZ_COPY.description, methodology: [], factors: ['Household', 'Style', 'Location', 'Budget'] },
  whenToUse: [], expertTips: [], faqs: [], relatedTools: [], features: [],
}
